import {default as Controller} from './AddDomainControl'
import {showModalPopup} from '../../redux/actions'
import {connect} from 'react-redux'
import {MODAL_POPUP_ID} from '../../redux/const'

const AddDomainControl = connect(
	(state) => ({
		visible: state.login.isLoggedIn
	}),
	(dispatch) => ({
		click: () => {
			dispatch(showModalPopup(MODAL_POPUP_ID.ADD_DOMAIN))
		}
	})
)(Controller)

AddDomainControl.defaultProps = {
	visible: null,
	click: null,
}

export default AddDomainControl


// WEBPACK FOOTER //
// ./src/components/AddDomainControl/index.js